import { currencyFormatter } from '@/helpers/currencyFormatter';
import { Modal, Box, Button, Icon } from '@palmetto/palmetto-components';
import { DateTime } from 'luxon';
import React, { useMemo } from 'react';

interface ApproveBatchConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  amount: number;
  batchDate?: string;
}

const ApproveBatchConfirmationModal: React.FC<ApproveBatchConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  amount,
  batchDate,
}) => {
  const formattedDate = useMemo(
    () => (batchDate ? DateTime.fromISO(batchDate).toFormat('EEEE MMM d, yyyy') : ''),
    [batchDate],
  );
  const summaryTextArray = `${currencyFormatter.format(amount)} on ${formattedDate}`.split(' ');
  const summaryTextGroups = [summaryTextArray.slice(0, 3).join(' '), summaryTextArray.slice(3).join(' ')];
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Confirm Payout Approval" onDismiss={onClose} maxWidth="5xl">
      <Modal.Body padding="0">
        <Box direction="row" childGap="sm" background="warning" padding="lg">
          <Box padding="sm">
            <Icon name="t-warning" size="xl" color="warning-500" />
          </Box>
          <Box>
            <Box childGap="md">
              <Box fontSize="md" fontWeight="bold">
                Confirm Payout Approval
              </Box>
              <Box>
                Once this payment is approved it cannot be undone. Please review the amount and date to ensure
                accuracy.
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal.Body>
      <Modal.Footer justifyContent="space-between">
        <Box>
          <Box>{summaryTextGroups[0]}</Box>
          <Box>{summaryTextGroups[1]}</Box>
        </Box>
        <Box alignContent="flex-end">
          <Box direction="row" childGap="sm">
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onConfirm}>
              Confirm Payout Approval
            </Button>
          </Box>
        </Box>
      </Modal.Footer>
    </Modal>
  );
};

export default ApproveBatchConfirmationModal;
